import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';

class StopWatch extends Component {
  render() {
    return (
      <div style={{ padding: '0 16px', textAlign: 'center' }}>
        <h4>This job is currently in progress</h4>
        <p style={{ textAlign: 'justify', marginBottom: '20px' }}>
          If you would like to end/pause this job, or request a contractor, you can do so clicking
          the buttons below.
        </p>
        <div className="row">
          <FlatButton
            label="End/Pause Job"
            type="button"
            primary={true}
            onClick={this.props.endPauseJob}
            className="previous"
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={{
              color: '#fff',
              height: '40px',
            }}
          />
        </div>
        <div className="row" style={{ marginTop: '10px' }}>
          <FlatButton
            label="Contractor Needed"
            type="button"
            onClick={this.props.toggleContractorDialog}
            className="previous"
            backgroundColor="#fff"
            hoverColor="grey"
            style={{
              color: AccentColor(),
              height: '40px',
            }}
          />
        </div>
      </div>
    );
  }
}

export default StopWatch;
